import { render, staticRenderFns } from "./IB.vue?vue&type=template&id=f8512b7e&"
import script from "./IB.vue?vue&type=script&lang=js&"
export * from "./IB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports